export const SITE_ALIASES_GRID_NAME = 'SiteAliasesGrid';
